// extracted by mini-css-extract-plugin
module.exports = {"container":"_3hFohGkepo18OObFTCZeaX","title":"_10gRByKYxuq_xTWVoYgBzD","description":"_22nlYxDBZj3soxnXvVmTBT","loading":"SoLHay2gvVMLlGO5sJgzn","link":"_2y_74gsINoS0FSjDZRAb-X"};